// チェックアウトボタンがクリックされたときに属性を更新してから遷移
document.querySelector('.cart__checkout')?.addEventListener('click', async function (e) {
  e.preventDefault(); // いったん遷移を止めて、属性更新後に遷移

  try {
    // のし情報を属性に反映
    await updateNoshiCartAttributes();

    // 属性反映後にチェックアウトへ遷移
    window.location.href = '/checkout';
  } catch (error) {
    console.error("チェックアウト前の属性更新エラー:", error);
    alert("カートの更新に失敗しました。もう一度お試しください。");
  }
});




// 商品追加処理
// document.querySelectorAll('.add-to-cart').forEach(button => {
//   button.addEventListener('click', async function(e) {
//     e.preventDefault();

//   // Variant ID（動的に取得）
//   const variantId = document.getElementById('product-variant-id').value;
//   var naireSelect = "";
//   var naireName = "";
//   var wrappingSelect = "";
//   var noshiSelect = "";
//   var noshiName = "";
  
  
//   // 名入れとのしの種類を取得
//   if(document.getElementById('naire-select') != null){
//     naireSelect = document.getElementById('naire-select').value;
//   }

//   if(document.getElementById('naire-name') != null){
//     naireName = document.getElementById('naire-name').value;
//   }

//   if(document.getElementById('wrapping-select') != null){
//     wrappingSelect = document.getElementById('wrapping-select').value;
//   }

//   if(document.getElementById('noshi-select') != null){
//     noshiSelect = document.getElementById('noshi-select').value;
//   }

//   if(document.getElementById('noshi-name') != null){
//     noshiName = document.getElementById('noshi-name').value;
//   }

//     const lineItemProperties = {
//       "名入れする書体": naireSelect,
//       "名入れする文字": naireName,
//       "ラッピング": wrappingSelect,
//       "のしの表書き": noshiSelect,
//       "贈り主の名前": noshiName
//     };

//     // Step 1: 商品追加
//     await fetch('/cart/add.js', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({
//         id: variantId,
//         quantity: 1,
//         properties: lineItemProperties
//       })
//     });

//     console.log("商品とアトリビュートを追加しました");

//     window.location.href = '/cart';
//   });
// });


// のし情報を再構成してCart Attributesを更新する関数
async function updateNoshiCartAttributes(e) {
  try {
    const response = await fetch('/cart.js');
    const cart = await response.json();
    // カートのアイテムごとにのし情報を抽出
    const items = cart.items || [];
    const attributes = {};
    let noshiIndex = 1;
    
    items.forEach(item => {
      const title = item.product_title || item.title;
      const variantTitle = item.variant_title || "";
      const options = item.options_with_values || [];

      // オプション名＋値を「サイズ：M／カラー：ブルー」みたいに結合
      let optionText = "";
      if (options.length > 0) {
        optionText = options.map(opt => `${opt.name}：${opt.value}`).join("／");
      }
    
      const properties = item.properties || {};
      const naireSelect = properties['名入れする書体'] || '';
      const naireName = properties['名入れする文字'] || '';
      const wrappingSelect = properties['ラッピング'] || '';
      const noshiSelect = properties['のしの表書き'] || '';
      const noshiName = properties['贈り主の名前'] || '';
    
      var info = "";
    
      if (wrappingSelect || noshiSelect || noshiName || naireSelect || naireName) {
        info = `商品名：${title}`;
        if (optionText) {
          info += `[${optionText}] `;
        }
      }
    
      if (wrappingSelect) info += `／ラッピング：${wrappingSelect}`;
      if (noshiSelect) info += `／のしの表書き：${noshiSelect}`;
      if (noshiName) info += `／贈り主の名前：${noshiName}`;
      if (naireSelect) info += `／名入れする書体：${naireSelect}`;
      if (naireName) info += `／名入れする文字：${naireName}`;
    
      if (info != "") {
        attributes[`のし情報_${noshiIndex}`] = info;
        console.log("デバッグ用：生成されたinfo =", info);
        noshiIndex++;
      }
    });


    // const noshiText = noshiInfoList.join('<br><br>');

    // カート属性を更新
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes }),
    });
  } catch (error) {
    console.error("カート属性の更新に失敗しました:", error);
  }
}